import { createI18n } from "vue-i18n";
import sv from "@/locales/sv";
import en from "@/locales/en";

const i18n = createI18n({
  legacy: false, // viktigt om du använder Composition API
  locale: localStorage.getItem("lang") || "sv",
  fallbackLocale: "en",
  messages: {
    sv,
    en,
  },
});

export default i18n;
